import { render, staticRenderFns } from "./CustomEditorReadonly.vue?vue&type=template&id=1a4c382e&scoped=true"
import script from "./CustomEditorReadonly.vue?vue&type=script&lang=js"
export * from "./CustomEditorReadonly.vue?vue&type=script&lang=js"
import style0 from "./CustomEditorReadonly.vue?vue&type=style&index=0&id=1a4c382e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c382e",
  null
  
)

export default component.exports